module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0620-098c03f75fc3df5825d68bf57d621e9a.jpg";